module.exports = __webpack_public_path__ + "img/18. Sharath Anchatageri.532f6d18.jpg";